import { createSlice } from "@reduxjs/toolkit";

/**
 * UI Slice - Manages global UI state during role switches
 *
 * Purpose:
 * - Freezes UI during Clerk metadata refresh to prevent blank screens
 * - Prevents AppRoutes from unmounting during role switch
 * - Ensures smooth 80-120ms transitions during Sponsor ↔ Vendor role switches
 */
const initialState = {
  freeze: false,
  isRoleSwitching: false,
  roleSwitchTimestamp: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setFreeze: (state, action) => {
      state.freeze = action.payload;
    },
    setRoleSwitching: (state, action) => {
      state.isRoleSwitching = action.payload;
      if (action.payload) {
        state.roleSwitchTimestamp = Date.now();
      }
    },
    startRoleSwitch: (state) => {
      state.freeze = true;
      state.isRoleSwitching = true;
      state.roleSwitchTimestamp = Date.now();
    },
    endRoleSwitch: (state) => {
      state.freeze = false;
      state.isRoleSwitching = false;
    },
  },
});

export const { setFreeze, setRoleSwitching, startRoleSwitch, endRoleSwitch } =
  uiSlice.actions;

// Selectors
export const selectUIFreeze = (state) => state.ui.freeze;
export const selectIsRoleSwitching = (state) => state.ui.isRoleSwitching;
export const selectRoleSwitchTimestamp = (state) =>
  state.ui.roleSwitchTimestamp;

export default uiSlice.reducer;
